import { render, staticRenderFns } from "./setting-page-layout.vue?vue&type=template&id=13fe486c&scoped=true"
import script from "./setting-page-layout.vue?vue&type=script&lang=js"
export * from "./setting-page-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fe486c",
  null
  
)

export default component.exports